import { render, staticRenderFns } from "./RemittanceScheduleConfigList.vue?vue&type=template&id=312018b6"
import script from "./RemittanceScheduleConfigList.vue?vue&type=script&lang=ts"
export * from "./RemittanceScheduleConfigList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports